/**
 * WpHeroIllustration.tsx — hero-illustrasjon for /wordpress
 *
 * Tre isometriske plattformer koblet med prikkede linjer: nettleservindu
 * (nettstedet), skjold (sikkerhet) og speedometer (ytelse). Samme stil og
 * temafarger som de andre produktsidene; kun blå og grå aksenter, og ingen
 * WordPress-logo (varemerke).
 */

import { Box, iso } from '@/components/product/iso';
import styles from '@/components/product/illustrations.module.css';
import { Browser, Gauge, Shield } from './parts';

export default function WpHeroIllustration({ label }: { label: string }) {
  const A = { x: -2.5, y: 0.5 }; // nettsted
  const B = { x: -2.5, y: -5.5 }; // skjold
  const C = { x: 3.5, y: -3.5 }; // ytelse
  const size = 5;

  const [sx, sy] = iso(B.x + size / 2, B.y + size / 2, 0.3).split(',').map(Number);
  const [gx, gy] = iso(C.x + size / 2, C.y + size / 2, 0.3).split(',').map(Number);

  return (
    <svg className={styles.scene} viewBox="110 40 660 420" role="img" aria-label={label}>
      <polyline className={styles.link} points={`${iso(A.x + 2, A.y, 0)} ${iso(B.x + 2.5, B.y + size, 0)}`} />
      <polyline className={styles.link} points={`${iso(B.x + size, B.y + 3, 0)} ${iso(C.x + 0.5, C.y, 0)}`} />
      <polyline className={styles.link} points={`${iso(A.x + size, A.y + 2, 0)} ${iso(C.x, C.y + 4.5, 0)}`} />

      {/* Bakerst: skjold */}
      <Box x={B.x} y={B.y} z={0} w={size} d={size} h={0.3} top={styles.top} left={styles.left} right={styles.right} />
      <Shield cx={sx} cy={sy} />

      {/* Høyre: speedometer */}
      <Box x={C.x} y={C.y} z={0} w={size} d={size} h={0.3} top={styles.top} left={styles.left} right={styles.right} />
      <Gauge cx={gx} cy={gy - 20} />

      {/* Foran: nettleservindu (nettstedet) */}
      <Box x={A.x} y={A.y} z={0} w={size} d={size} h={0.3} top={styles.top} left={styles.left} right={styles.right} />
      <Browser x={A.x + 0.6} y={A.y + 1.1} z={0.3} />
    </svg>
  );
}
